module.exports = __webpack_public_path__ + "static/media/HeartIcon.8893ec38.svg";